function cov_pse3inlu2() {
  var path = "/app/src/components/icon/index.ts";
  var hash = "a6774b1551284f8917acdea3dd495e1f4ed2a58f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/icon/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a6774b1551284f8917acdea3dd495e1f4ed2a58f"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_pse3inlu2 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_pse3inlu2();
export { Icon } from './icon';